export const checkWGLAvailability = () => {
    let available = false;
    const canvas = document.createElement('canvas');
    const context = window.WebGLRenderingContext;
    const webglContext = canvas.getContext('webgl');
    const webglExpContext = canvas.getContext('experimental-webgl');
    available = !!(context && (webglContext || webglExpContext));
    if (canvas && canvas.remove)
        canvas.remove();
    return available;
};
//# sourceMappingURL=webGLCheck.js.map